
import ssoImg1 from "./../../../../assets/images/SHIPREGISTRY.png"; // Adjust the path as necessary

function ShipRegistryOverviewTab() {


  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        SHIP REGISTRY 
        <span className="text-orange-ef3e33 font-400"> overview </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          
          <p className="mb-3 text-primary-color">The Registration of a vessel is required under UN Law of the Sea convention and is governed by the Ship Registration Act.</p>
          <p className="mb-3 text-primary-color">It is an International Proclamation of the ownership and the purpose of  vessel. The vessel must have a Genuine Link to Flag State.</p>
          <p className="mb-3 text-primary-color">The Ship Registration Act allows for South Africans to register in South  Africa and thus fly the South African Flag on their vessels.</p>
          <p className="mb-3 text-primary-color">Registration is required if the vessel is operating outside the  maritime zones of South Africa. (On the high seas and inside another  states maritime zones.)</p>
          <p className="mb-3 text-primary-color">Foreign States can obtain information regarding SA registered vessels from Registrar of Ships.</p>
        </div>
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div>
        
      </div>
    </>
  );
}

export default ShipRegistryOverviewTab;